import { type CMSExplorePageBubbleNavItem } from '../cms/types';
import { appendParams } from '../routing/appendParams/appendParams';

export const MIN_ITEMS = 2;
export const MAX_ITEMS = 32;

export function filterBubbleNavItems(items?: CMSExplorePageBubbleNavItem[]) {
  if (!items || items.length < MIN_ITEMS) {
    return [];
  }
  if (items.length > MAX_ITEMS) {
    // return the first X items
    return items.slice(0, MAX_ITEMS);
  }

  return items;
}

export function transformBubbleNavItems(
  items: CMSExplorePageBubbleNavItem[],
  moduleName: string
) {
  return filterBubbleNavItems(items).map((item) => ({
    label: item.title,
    imgSrc: item.image?.url,
    imgAlt: '',
    url: appendParams(item.url ? item.url : '', ['moduleOrigin', moduleName]),
  }));
}
